import script from "./TabInteresses.vue?vue&type=script&setup=true&lang=js"
export * from "./TabInteresses.vue?vue&type=script&setup=true&lang=js"

import "./TabInteresses.vue?vue&type=style&index=0&id=e6925fba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6925fba"]])

export default __exports__